import { faUser } from "@fortawesome/free-solid-svg-icons";
import { isPositiveNumber } from "et3-type-guards";
import React from "react";
import i18n from "../../../../constants/i18n";
import getUserConversationStore from "../../../../stores/user-store/conversation-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const ConversationForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"number"}
          icon={faUser}
          label={i18n.get("SENDER_ID")}
          placeHolder={i18n.get("SENDER_ID")}
          onChoose={(value: number) => {
            getUserConversationStore().setSenderIdInput(value);
          }}
          onBlur={() => {}}
          value={getUserConversationStore().senderIdInput.get()}
          onEnter={() => {}}
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"number"}
          icon={faUser}
          label={i18n.get("RECEIVER_ID")}
          placeHolder={i18n.get("RECEIVER_ID")}
          onChoose={(value: number) => {
            getUserConversationStore().setRecipientIdInput(value);
          }}
          onBlur={() => {}}
          value={getUserConversationStore().recipientIdInput.get()}
          onEnter={() =>
            getUserConversationStore().getConversation({
              isLoadMore: false
            })
          }
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("LIMIT")}
          onChoose={(value: TEt3PickerSingleValue) => {
            getUserConversationStore().setMessagesLimit(value);
          }}
          value={getUserConversationStore().messagesLimit.get()}
          options={[
            { label: "50", value: "50" },
            { label: "100", value: "100" },
            { label: "250", value: "250" },
            { label: "500", value: "500" }
          ]}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("MESSAGE_ERA")}
          options={[
            { label: "POST_2025", value: "POST_2025" },
            { label: "PRE_2025", value: "PRE_2025" }
          ]}
          value={getUserConversationStore().messageEra.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getUserConversationStore().setMessageEra(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={
          isPositiveNumber(getUserConversationStore().senderIdInput.get()) &&
          isPositiveNumber(getUserConversationStore().recipientIdInput.get())
        }
        onClick={async () =>
          await getUserConversationStore().getConversation({
            isLoadMore: false
          })
        }
        type="GET"
        size="LARGE"
        text="GET"
      />
    </React.Fragment>
  );
});
export default ConversationForm;
